import React from 'react';

const HeroSection = () => {
  return (
    <section className="mx-auto mt-[54px] max-w-[1240px] px-10 text-center max_sm:mt-[32px] max_sm:px-5">
      <div className="mx-auto max-w-[900px]">
        <p className="mb-3 text-[12px] font-DMSansFont font-bold uppercase tracking-[0.18em] text-ButtonPrimary">
          Software & payment system pricing
        </p>
        <h1 className="font-DMSansFont text-[54px] font-bold leading-[1.04] tracking-[-2.2px] text-LightPrimary max_md:text-[43px] max_sm:text-[34px] max_sm:tracking-[-1px]">
          Pay for what you use. Nothing more.
        </h1>
        <p className="mx-auto mt-4 max-w-[720px] text-[18px] font-DMSansFont leading-7 text-LightTextParagraph max_sm:text-[15px] max_sm:leading-6">
          Choose a software plan for customer engagement, use the payment system on its own, or combine both—then scale capacity as you grow.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
